/** Detects if the CBPay widget is embedded within an iframe */
export const getIsEmbedded = () => window.parent !== window.self;
